/* Kit Builder — whole-bundle removal in cart surfaces.
   One click zeroes every line sharing the bundle's _kit_id via a single
   /cart/update.js call (keys carried on data-kit-keys, per Shane's MBS pattern).
   Loaded globally from theme.liquid; delegated + idempotent. */
(function () {
  'use strict';
  if (document.documentElement.dataset.kitCartBound) return;
  document.documentElement.dataset.kitCartBound = 'true';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kit-remove]');
    if (!btn || btn.dataset.kitBusy) return;
    e.preventDefault();
    e.stopPropagation();
    btn.dataset.kitBusy = 'true';

    var updates = {};
    (btn.getAttribute('data-kit-keys') || '').split(',').forEach(function (pair) {
      var key = pair.split('|')[0];
      if (key) updates[key] = 0;
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: ['mini-cart', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (window.location.pathname.indexOf('/cart') === 0) {
          window.location.reload();
          return;
        }
        var mc = document.querySelector('mini-cart');
        if (mc && typeof mc.renderContents === 'function' && json.sections) {
          mc.renderContents(json);
        } else {
          window.location.reload();
        }
      })
      .catch(function () { window.location.reload(); })
      .finally(function () { delete btn.dataset.kitBusy; });
  });
})();
